import "../plugins/templates";
import MapPlaces from "../maps/mapPlaces";
import 'bootstrap-slider/dist/bootstrap-slider';

window.agencySearch = {};

(function () {

    agencySearch = new MapPlaces({
        defaultIcon: '/_assets/cb52561705753b7640fdeb0739dcb280/Images/Icons/signal-iduna-map-marker.svg',
        hoverIcon: '/_assets/cb52561705753b7640fdeb0739dcb280/Images/Icons/signal-iduna-map-marker.svg',
        renderListEntry: hbs.templates.agencySearch.resultListEntry,
        renderMapsInfoBox: hbs.templates.agencySearch.mapsInfoBox,
        citySearchSelector: '#agencySearchCity',
        place: {
            latKey: 'lat',
            lngKey: 'lng',
            markerTitleKey: 'name'
        }
    });

    var $agencySearchForm = $('#agencySearchForm');
    var $agencySearchCity = $('#agencySearchCity');
    var $agencySearchZip = $('#agencySearchZip');
    var $agencySearchRadius = $('#agencySearchRadius');
    var $agencySearchName = $('#agencySearchName');
    var $agencySearchRadiusValueText = $('#agencySearchRadiusValueText');
    var prevCity = '';


    $agencySearchForm.find('input:checkbox').change(function (e) {
        formSubmit();
    });
    $agencySearchZip.keypress(submitByEnter);
    $agencySearchZip.on('change', submitSearchForm);
    $agencySearchRadius.keypress(submitByEnter);
    $agencySearchName.keyup(function (e) {
        if ($agencySearchName.val().length > 0 && $agencySearchName.val().length < 3) {
            $agencySearchName.addClass('is-invalid');
        } else {
            $agencySearchName.removeClass('is-invalid');
            submitByEnter(e);
        }
    });
    $agencySearchName.on('change', submitSearchForm);

    $agencySearchForm.on('submit', function (e) {
        e.preventDefault();

        var city = $agencySearchCity.val();
        if (city !== '' && city !== 'Ort nicht gefunden' && prevCity !== city) {
            agencySearch.centerMapAtAddress(city);
        }
        prevCity = city;

        var params = {
            "ort": city,
            "zip": $agencySearchZip.val(),
            "radius": $agencySearchRadius.val(),
            "name": $agencySearchName.val(),
            "p34i": $('#agencySearchP34i:checked').val(),
            "p34f": $('#agencySearchP34f:checked').val()
        };

        $.post(apiUri, params, function (data) {
            agencySearch.setPlaces(data);
        }, 'json').fail(function (a, b, c) {
            console.log('fehler');
        });
    });

    var radiusChangeTimeout = null;
    $agencySearchRadius.on('change', function (e) {
        $agencySearchRadiusValueText.text($agencySearchRadius.val());
        if (radiusChangeTimeout) {
            clearTimeout(radiusChangeTimeout);
        }
        radiusChangeTimeout = setTimeout(function () {
            formSubmit();
        }, 600);
    });

    $agencySearchZip.keyup(function () {
        if ($agencySearchZip.val().length === 5) {
            $agencySearchZip.removeClass('is-invalid');
            $.ajax({
                url: "https://api.zippopotam.us/de/" + $agencySearchZip.val(),
                cache: false,
                dataType: "json",
                type: "GET",
                success: function (result, success) {
                    // German Post Code Records Officially Map to only 1 Primary Location
                    var places = result['places'][0];
                    $agencySearchCity.val(places['place name'] + ', ' + places['state']);
                    $agencySearchCity.removeClass('is-invalid');
                },
                error: function (result, success) {
                    $agencySearchCity.val('Ort nicht gefunden');
                    $agencySearchCity.addClass('is-invalid');
                }
            });
        } else if ($agencySearchZip.val().length !== 0) {
            $agencySearchZip.addClass('is-invalid');
        } else {
            $agencySearchZip.removeClass('is-invalid');
        }
    });

    function submitByEnter(e) {
        if (e.which === 13) {
            e.preventDefault();
            formSubmit();
        }
    }

    function formSubmit() {
        if ($agencySearchName.val().length > 2 || $agencySearchZip.val().length === 5) {
            submitSearchForm();
        }
    }

    function submitSearchForm() {
        $agencySearchForm.submit();
    }

})();

